export enum ClientType {
  UkRegulated = 'uk_regulated',
  UkUnregulated = 'uk_unregulated',
  UkAgent = 'uk_agent',
  EuRegulated = 'eu_regulated',
  EuUnregulated = 'eu_unregulated',
}
